/**
 * Kí hiệu tiền tệ
 */
export default {
  NormalVND: 'đ',
  UpperCaseVND: 'Đ',
  None: 0,
};
